import { render, staticRenderFns } from "./TopBarSubinstanceBar.vue?vue&type=template&id=0305c6fc&scoped=true"
import script from "./TopBarSubinstanceBar.vue?vue&type=script&lang=js"
export * from "./TopBarSubinstanceBar.vue?vue&type=script&lang=js"
import style0 from "./TopBarSubinstanceBar.vue?vue&type=style&index=0&id=0305c6fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0305c6fc",
  null
  
)

export default component.exports